<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="CONTABILIDAD" key="1">
      <a-collapse>
        <a-collapse-panel key="1" header="Consulta de contabilidad">
          <a-spin :spinning="loading">
            <a-row :gutter="[8,16]">
              <a-col v-bind="colOptionsTabs">
                <a-card title="Nómina de empleados">
                  <p>Débito: <b> {{consultaContabilidad.nom_deb}}
                  </b></p>
                  <p>Crédito: <b> {{consultaContabilidad.nom_cre}}
                  </b></p>
                  <p>Diferencia: <b> {{consultaContabilidad.nom_dif}} </b></p>
                </a-card>
              </a-col>
              <a-col v-bind="colOptionsTabs">
                <a-card title="Provisión de empleados">
                  <p>Débito: <b> {{consultaContabilidad.prv_deb}}
                  </b></p>
                  <p>Crédito: <b> {{consultaContabilidad.prv_cre}}
                  </b></p>
                  <p>Diferencia: <b> {{consultaContabilidad.prv_dif}}</b></p>
                </a-card>
              </a-col>
              <a-col v-bind="colOptionsTabs">
                <a-card title="Aporte seg. social de empleados">
                  <p>Débito: <b> {{consultaContabilidad.sso_deb}}
                  </b></p>
                  <p>Crédito: <b> {{consultaContabilidad.sso_cre}}
                  </b></p>
                  <p>Diferencia: <b> {{consultaContabilidad.sso_dif}}</b></p>
                </a-card>
              </a-col>
              <a-col v-bind="colOptionsTabs" style="width: 300px">
                <a-card title="Pagos nómina empleados">
                  <p>Débito: <b> {{consultaContabilidad.nxp_deb}}
                  </b></p>
                  <p>Crédito: <b> {{consultaContabilidad.nxp_cre}}
                  </b></p>
                  <p>Diferencia: <b> {{consultaContabilidad.nxp_dif}}</b></p>
                </a-card>
              </a-col>
              <a-col v-bind="colOptionsTabs" style="width: 250px">
                <a-card title="Pagos SOI">
                  <p>Débito: <b> {{consultaContabilidad.soi_deb}}
                  </b></p>
                  <p>Crédito: <b> {{consultaContabilidad.soi_cre}}
                  </b></p>
                  <p>Diferencia: <b> {{consultaContabilidad.soi_dif}}</b></p>
                </a-card>
              </a-col>
            </a-row>
          </a-spin>
        </a-collapse-panel>
      </a-collapse>
      <br>
      <div style="display:flex; justify-content:flex-end;">
        <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
      </div>
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                modalWidth="60%"
                @handleOk="handleOk"
                @action="masterAction"
                ref="master"
                :parentData="parentData"
                :modalFieldsSetup="master.modalFieldsSetup"
                :actions="false"
                @params="paramsTable"
      >
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>

        <template slot="masterModal" slot-scope="{record}">
          <template>
            <a-tabs :active-key="activeKeyModal" @change="changeTab">
              <a-tab-pane key="1" force-render>
                <span slot="tab">
                  <a-icon type="alert"/>
                  Datos obligatorios
                </span>
                <a-row :gutter="[16,16]">
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                      <a-select v-decorator="['mes', { rules: [
                            { required: true, message: 'Valor requerido'},
                           ] }]" style="width: 100%">
                        <a-select-option v-for="month_ in months_name" :key="month_.value">
                          {{ month_.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Año')" v-bind="fiOptions">
                      <a-select :default-value="yearToday" v-decorator="['ano', { rules: [
                            { required: true, message: 'Valor requerido' },
                           ] }]" style="width: 100%">
                        <a-select-option v-for="year_ in years" :key="year_">
                          {{ year_ }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Periodo')">
                      <a-input-number :min="0" :max="9" v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['periodo', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('ID concepto')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Fecha inicial')" v-bind="fiOptions">
                      <a-date-picker style="width: 100%"
                                     type="date"
                                     valueFormat="Y-MM-DD HH:mm:ss"
                                     v-decorator="['date_ini', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Fecha final')" v-bind="fiOptions">
                      <a-date-picker style="width: 100%"
                                     type="date"
                                     valueFormat="Y-MM-DD HH:mm:ss"
                                     v-decorator="['date_to', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Fecha y hora del sistema')">
                      <a-date-picker style="width: 100%"
                                     disabled
                                     format="YYYY-MM-DD HH:mm"
                                     show-time
                                     type="date"
                                     valueFormat="Y-MM-DD HH:mm:ss"
                                     placeholder="Select Time"
                                     v-decorator="['date_system', { rules: [{ required: true, message: 'Valor requerido' }], initialValue: now }]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Ammount')">
                      <a-input-number
                        style="width: 100%"
                        v-decorator="['ammount', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('AmmountL')">
                      <a-input-number
                        style="width: 100%"
                        v-decorator="['ammount_l', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('N1')">
                      <a-input
                        v-decorator="['n1', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('N6')">
                      <a-input
                        v-decorator="['n6', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Cc 1')">
                      <a-input-number :min="0" :max="9999" v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['cc1', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Cc consec')">
                      <a-input
                        v-decorator="['cc_consec', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Cod. tipo comp')">
                      <a-input-number :min="0" :max="9999" v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['cod_tipcomp', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="2" force-render>
                <span slot="tab">
                  <a-icon type="number"/>
                  N#
                </span>
                <a-row :gutter="[16,16]">
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('N2')">
                      <a-input
                        v-decorator="['n2', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('N3')">
                      <a-input
                        v-decorator="['n3', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('N4')">
                      <a-input
                        v-decorator="['n4', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('N5')">
                      <a-input
                        v-decorator="['n5', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="3" force-render>
                <span slot="tab">
                  <a-icon type="container"/>
                  Otros
                </span>
                <a-row :gutter="[16,16]">
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Otros 1')">
                      <a-input
                        v-decorator="['otros1', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Otros 2')">
                      <a-input
                        v-decorator="['otros2', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Otros 3')">
                      <a-input
                        v-decorator="['otros3', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Otros 4')">
                      <a-input
                        v-decorator="['otros4', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Otros 5')">
                      <a-input
                        v-decorator="['otros5', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="4" force-render>
                <span slot="tab">
                  <a-icon type="profile"/>
                  Otros datos
                </span>
                <a-row :gutter="[16,16]">
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Centro de costo')">
                      <a-input
                        v-decorator="['cencos', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Cc 2')">
                      <a-input
                        v-decorator="['cc2', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Cc 3')">
                      <a-input-number :min="0" :max="9999" v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['cc3', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Cc 4')">
                      <a-input-number :min="0" :max="9999" v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['cc4', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Cc 5')">
                      <a-input-number :min="0" :max="9999" v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['cc5', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Cc 6')">
                      <a-input-number :min="0" :max="9999" v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['cc6', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Oficina')">
                      <a-input-number :min="0" :max="9999" v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['office', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Doc. 1')">
                      <a-input
                        v-decorator="['docu1', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Doc. 2')">
                      <a-input
                        v-decorator="['docu2', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Consec comp')">
                      <a-input-number :min="0" :max="999999" v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['consec_comp', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Form. liq.')">
                      <a-input
                        v-decorator="['form_liq', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-tab-pane>
            </a-tabs>
          </template>
        </template>
      </g-master>
    </a-tab-pane>
    <a-tab-pane tab="HISTÓRICO DE CONTABILIDAD" key="2">
      <ctb-hist></ctb-hist>
    </a-tab-pane>
  </a-tabs>

</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        fileNameExcel: 'contabilidad',
        paramsT: {},
        endpointExcel: 'contabilidad/downloadExcel',
        activeKeyModal: '1',
        loading: true,
        consultaContabilidad: {},
        numberAction: 0,
        now: moment().format('Y-MM-DD HH:mm:ss'),
        colOptions: {xs: 24, sm: 8},
        colOptionsTabs: {xs: 24, sm: 5},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {},
          'has-feedback': true
        },
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        years: [],
        yearToday: parseInt(moment().format('YYYY')),
        master: {
          valoresExpandidos: [
            {label: 'Fecha inicial', column: 'fecha_inicio'},
            {label: 'Fecha final', column: 'fecha_fin'},
            {label: 'N2', column: 'n2'},
            {label: 'N3', column: 'n3'},
            {label: 'N4', column: 'n4'},
            {label: 'N5', column: 'n5'},
            {label: 'Centro de costo', column: 'cencos'},
            {label: 'Cc1', column: 'cc1'},
            {label: 'Cc2', column: 'cc2'},
            {label: 'Cc3', column: 'cc3'},
            {label: 'Cc4', column: 'cc4'},
            {label: 'Cc5', column: 'cc5'},
            {label: 'Cc6', column: 'cc6'},
            {label: 'Oficina', column: 'office'},
            {label: 'Doc. 1', column: 'docu1'},
            {label: 'Otros1', column: 'otros1'},
            {label: 'Otros2', column: 'otros2'},
            {label: 'Otros3', column: 'otros3'},
            {label: 'Otros4', column: 'otros4'},
            {label: 'Otros5', column: 'otros5'},
            {label: 'Cc consec', column: 'cc_consec'},
            {label: 'Consec comp', column: 'consec_comp'},
            {label: 'Fecha del sistema', column: 'date_system'},
            {label: 'Nombre de usuario', column: 'usercompany'}
          ],
          endpoint: 'ctb',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID Cñía', dataIndex: 'id_company', sorter: true},
              {title: 'ID Empleado', dataIndex: 'id_emp', sorter: true, width: 140},
              {title: 'Nombre Empleado', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'Año', dataIndex: 'ano', sorter: true, width: 90},
              {title: 'Mes', dataIndex: 'mes_desc', sorter: true, width: 90},
              {title: 'Periodo', dataIndex: 'periodo', sorter: true, width: 110},
              {title: 'ID Concepto', dataIndex: 'id_coc', sorter: true, width: 130},
              {title: 'Nombre Concepto', dataIndex: 'coc_name', sorter: true, width: 140},
              {title: 'Nat. Concepto', dataIndex: 'docu2', sorter: true, width: 130},
              {title: 'Valor', dataIndex: 'ammount', sorter: true},
              {title: 'Valor Total', dataIndex: 'ammount_l', sorter: true, width: 120},
              {title: 'Cuenta Contable', dataIndex: 'n1', sorter: true, width: 140},
              {title: 'Nat. Cuenta', dataIndex: 'n6', sorter: true, width: 110},
              {title: 'Tipo Comprobante', dataIndex: 'cod_tipcomp', sorter: true, width: 150},
              {title: 'Tipo Pago', dataIndex: 'form_liq', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'ammount'},
            {name: 'ammount_l'},
            {name: 'ano'},
            {name: 'cc1'},
            {name: 'cc2'},
            {name: 'cc3'},
            {name: 'cc4'},
            {name: 'cc5'},
            {name: 'cc6'},
            {name: 'cc_consec'},
            {name: 'cencos'},
            {name: 'cod_tipcomp'},
            {name: 'consec_comp'},
            {name: 'date_ini'},
            {name: 'date_system'},
            {name: 'date_to'},
            {name: 'docu1'},
            {name: 'docu2'},
            {name: 'form_liq'},
            {name: 'id_coc'},
            {name: 'id_emp'},
            {name: 'mes'},
            {name: 'n1'},
            {name: 'n2'},
            {name: 'n3'},
            {name: 'n4'},
            {name: 'n5'},
            {name: 'n6'},
            {name: 'office'},
            {name: 'otros1'},
            {name: 'otros2'},
            {name: 'otros3'},
            {name: 'otros4'},
            {name: 'otros5'},
            {name: 'periodo'}
          ]
        }
      }
    },
    mounted () {
      this.yearsSelect()
      this.httpClient = new HttpUtil()
      this.getTabsConsultaContabilidad()
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.$refs.master.modal.form.setFieldsValue({
              date_system: moment().format('Y-MM-DD HH:mm:ss')
            })
            break
        }
      },
      changeTab (e) {
        this.activeKeyModal = e
      },
      handleOk (item) {
        if (JsUtils.isEmpty(item.mes) || JsUtils.isEmpty(item.ano) || JsUtils.isEmpty(item.periodo) ||
          JsUtils.isEmpty(item.id_coc) || JsUtils.isEmpty(item.date_ini) || JsUtils.isEmpty(item.date_to) ||
          JsUtils.isEmpty(item.date_system) || JsUtils.isEmpty(item.n1) || JsUtils.isEmpty(item.ammount) ||
          JsUtils.isEmpty(item.ammount_l)) {
          this.activeKeyModal = '1'
        }
      },
      getTabsConsultaContabilidad () {
        let self = this
        this.httpClient.getInstance().get('ctb_tabs').then((response) => {
          this.loading = false
          var prueba = response.data
          response.data.nom_deb = new Intl.NumberFormat().format(prueba.nom_deb)
          response.data.nom_cre = new Intl.NumberFormat().format(prueba.nom_cre)
          response.data.nom_dif = new Intl.NumberFormat().format(prueba.nom_dif)

          response.data.nxp_deb = new Intl.NumberFormat().format(prueba.nxp_deb)
          response.data.nxp_cre = new Intl.NumberFormat().format(prueba.nxp_cre)
          response.data.nxp_dif = new Intl.NumberFormat().format(prueba.nxp_dif)

          response.data.prv_deb = new Intl.NumberFormat().format(prueba.prv_deb)
          response.data.prv_cre = new Intl.NumberFormat().format(prueba.prv_cre)
          response.data.prv_dif = new Intl.NumberFormat().format(prueba.prv_dif)

          response.data.soi_deb = new Intl.NumberFormat().format(prueba.soi_deb)
          response.data.soi_cre = new Intl.NumberFormat().format(prueba.soi_cre)
          response.data.soi_dif = new Intl.NumberFormat().format(prueba.soi_dif)

          response.data.sso_deb = new Intl.NumberFormat().format(prueba.sso_deb)
          response.data.sso_cre = new Intl.NumberFormat().format(prueba.sso_cre)
          response.data.sso_dif = new Intl.NumberFormat().format(prueba.sso_dif)
          self.consultaContabilidad = response.data
        }).catch(() => {
          this.loading = false
          Mensajes.error('Error', 'No fue posible cargar la información de la encuesta.')
        })
      },
      yearsSelect () {
        for (let i = 1990; i <= (this.yearToday + 20); i++) {
          this.years.push(i)
        }
      }
    },
    computed: {
      parentData () {
        return {filter_parent_ctb: true}
      },
      paramsExcel () {
        return {...this.paramsT, ...this.parentData}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Consultas/Ctb.vue